import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control, Watch} from 'react-hook-form';

import {colors} from 'shells/colors/colors';
import {EditableFormField} from 'shells/form/editable-form-field';
import {FileUploadIcon} from 'shells/icon/svg/file-upload-icon';

import {hexToRgba} from '../../../../helpers';
import type {ElementType} from '../../../../types';

import styles from './field-styles.module.css';

type Props = {
    control: Control;
    name: string;
    watch: Watch;
    isActive: boolean;
    activeElement: ElementType | null | undefined;
};

export function FileUploadField(props: Props) {
    const [shouldFocusOnMount, setShouldFocusOnMount] = React.useState<boolean>(
        Boolean(props.isActive && props.activeElement && props.activeElement === 'label')
    );
    const isRequired = props.watch(`${props.name}.isRequired`);
    const color = props.watch('inputStyle.color');
    const fontSize = props.watch('inputStyle.fontSize');
    const border = props.watch('inputStyle.border');
    const borderRadius = props.watch('inputStyle.borderRadius');

    const placeholderHeight = Number(fontSize) + 16;

    return (
        <div style={{fontSize: `${fontSize}px`}}>
            <Controller
                name={`${props.name}.label`}
                control={props.control}
                rules={{
                    maxLength: {
                        value: 255,
                        message: 'Field names can’t exceed 255 characters',
                    },
                }}
                // @ts-expect-error
                render={({field, fieldState}) => {
                    const errorMessage = fieldState.error ? fieldState.error.message : undefined;

                    return (
                        <EditableFormField
                            innerId={field.id}
                            label={field.value}
                            errorMessage={errorMessage}
                            smallBottomMargin={true}
                            editableLabelProps={{
                                onSaveNewValue: (newName) => {
                                    field.onChange(newName);

                                    return new Promise((resolve) => {
                                        // @ts-expect-error
                                        resolve();
                                    });
                                },
                                placeholder: 'Add a title',
                                allowSavingEmpty: false,
                                shouldAllowUndo: false,
                                required: isRequired,
                                tooltip: null,
                                // @ts-expect-error
                                customStyle: {color},
                                isWhite: true,
                                shouldFocusOnMount,
                                onFocusedOnMount: () => setShouldFocusOnMount(false),
                            }}
                            isActive={props.isActive}
                        >
                            <div className={styles['file-upload']}>
                                <div
                                    style={{
                                        border,
                                        borderRadius,
                                        height: placeholderHeight,
                                    }}
                                    className={styles['upload-placeholder']}
                                >
                                    <div className={styles['upload-icon']}>
                                        {/* @ts-expect-error */}
                                        <FileUploadIcon size={fontSize} fill={colors.greyLt} />
                                    </div>
                                    <span className={styles['upload-text']}>Upload</span>
                                </div>
                                <div
                                    style={{color: hexToRgba(color, 0.6)}}
                                    className={styles['upload-max']}
                                >
                                    Maximum size: 50 MB
                                </div>
                            </div>
                        </EditableFormField>
                    );
                }}
            />
        </div>
    );
}
